import React from "react";

export default function DestinationDropdown({ visaCountries, searchQuery, setSearchQuery, onSelect }) {
  return (
    <div className="sb--fromcity--dropdown visacountry--dropdown" onClick={(e) => e.stopPropagation()}>
      <div className="sb--searchWrapper">
        <img src="https://tripprizer.com/static/media/search-icon.7ebd75c1b1b96ff37293.svg" alt="search" />
        <input 
          type="text" 
          placeholder="Enter Region" 
          value={searchQuery}
          onChange={(e) => setSearchQuery(e.target.value)}
        />
      </div>
      
      <div className="sb--airport--scroll">
        <div className="sb--airport--heading">Recent Searches</div>
        <ul className="sb--airport-list">
          {visaCountries.slice(0, 3).map((item, idx) => (
            <li key={idx} onClick={() => onSelect(item.name)}>
              <div className="visacountry--left-list">
                <div className="sb--airport--img"><img src={item.flag} alt="flag" /></div>
                <div className="sb--airport-left">
                  <div className="sb--airport--cityname">{item.name}</div>
                  <div className="sb--visatype--ddowntag">{item.type}</div>
                </div>
              </div>
              <div className="visacountry--right-list">
                <div className="visa--nontype">Tourist</div>
                <div className="visa--nontype">Business</div>
              </div>
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
}